module.exports = __webpack_public_path__ + "img/zfn_logo.3614ca47.svg";